import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";

export default function CheckboxQuestion({ question, grpQuestion, onChange }) {
	return (
		<Col className="mb-3" md={question.size ? question.size : 12} key={question.question}>
			<div className="question-header" style={{marginBottom: "15px"}}>
        {question?.question}
      </div>
      {question?.checkboxOptions?.map((i, idx) => (
        <Form.Check
          key={idx}
          type={"checkbox"}
          label={i}
          checked={question.patient_answer?.find(x => x === i)}
          onChange={(e) => onChange(question._id, i, question?.questionType, grpQuestion)}
        />
      ))}
  </Col>
	);
}
